exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___2dYa0{padding:0 20px}.style__box___3IVot{height:10px;border-left:1px solid #979797}.style__imgContainer___o-n3I{position:relative}.style__img___etnLb{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.style__box___3IVot.style__bottom___gtHJ4{border-top:1px solid #979797}.style__element___3WB4S{word-spacing:normal;padding-top:8px;position:relative}.style__description___f6aZG,.style__element___3WB4S{text-align:center;font-family:PlayfairDisplay-Regular;font-size:12px;letter-spacing:.4px;color:#333}.style__description___f6aZG{width:220px;padding-top:24px;font-style:italic}.style__itemGroup___1tqE8{border-right:1px solid #979797}.style__itemGroup___1tqE8:last-of-type{border-right:none}.style__itemGroup___1tqE8:last-child .style__item___2eraC:last-child .style__box___3IVot{border-right:1px solid #979797}.style__itemGroup___1tqE8:not(:first-child) .style__item___2eraC:first-child .style__box___3IVot{border-left:none}", ""]);

// exports
exports.locals = {
	"container": "style__container___2dYa0",
	"box": "style__box___3IVot",
	"imgContainer": "style__imgContainer___o-n3I",
	"img": "style__img___etnLb",
	"bottom": "style__bottom___gtHJ4",
	"element": "style__element___3WB4S",
	"description": "style__description___f6aZG",
	"itemGroup": "style__itemGroup___1tqE8",
	"item": "style__item___2eraC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/scale/style.css
// module id = 708
// module chunks = 0